"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _InfoIcon = require("./InfoIcon");
Object.keys(_InfoIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _InfoIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InfoIcon[key];
    }
  });
});